import { useEffect, useState } from 'react';
import apiService from '../../axios/apiService';
import { useLocation } from 'react-router-dom';
import { getSearchParamFromLocation } from '../../utils/mapper';
import { ApplicationRoutes } from '../../authguard/routes';

export const useGetInvoice = () => {
  const [data, setData] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const getInvoice = async () => {
    // Fetch invoice
    setLoading(true);
    try {
      const id = getSearchParamFromLocation('id', location);
      if(!id) return;
      const response = await apiService.getInvoice(id);
      response && setData(response); // update data state
      return response;
    } catch (error) {
      console.log('Fetch Invoice Error: ', error);
    } finally {
      setLoading(false);
    }
  };

  // Initial component mount
  useEffect(() => {
    if (location?.pathname === ApplicationRoutes.InvoiceEdit) {
      getInvoice();
    }
  }, [location?.search]);

  return {
    data,
    loading,
    getInvoice,
  };
};
